if (!customElements.get('thumbnail-slider')) {
  class ThumbnailSlider extends SliderComponent {
    constructor() {
      super();
    }
  
    init() {
      super.init();
  
      const variantItems = this.querySelectorAll('.thumbnail-list_item--variant:not(.is-active)');
      this.slider.dataset.mediaCount = this.sliderItems.length - variantItems.length;
  
      if(this.querySelector('[data-gang-option]')) {
        const inactiveGangItems = this.querySelectorAll('[data-gang-option]:not(.gang__active)');
        this.slider.dataset.mediaCount = this.sliderItems.length - inactiveGangItems.length;
      }
  
      if (this.slider.dataset.mediaCount < 2) this.classList.add('hidden');
    }
  }
    customElements.define('thumbnail-slider', ThumbnailSlider);
}

if (!customElements.get('product-gallery')) {
  class ProductGallery extends SliderComponent {
    constructor() {
      super();
    }
  
    init() {
      super.init();
  
      const gallerySliderButtons = this.querySelector('.slider-buttons');
      if (gallerySliderButtons && this.querySelector('[data-gang-option]')) {
        if (this.querySelectorAll('.product__media-item.gang__active').length < 2) {
          gallerySliderButtons.classList.add('hidden');
        } else {
          gallerySliderButtons.classList.remove('hidden');
        }
      }
  
      this.cursor = this.querySelector('.gallery-cursor');
      if (!this.cursor) return;
  
      const images = this.querySelectorAll('.product__modal-opener--image');
      images.forEach((image) => image.addEventListener('mousemove', this.onMoveHandler.bind(this)));
      images.forEach((image) => image.addEventListener('mouseenter', this.onEnterHandler.bind(this)));
      images.forEach((image) => image.addEventListener('mouseleave', this.onLeaveHandler.bind(this)));
    }
  
    onMoveHandler(event) {
      this.cursor.style.left = `${event.clientX - 32}px`;
      this.cursor.style.top = `${event.clientY - 32}px`;
    }
  
    onEnterHandler() {
      this.cursor.classList.add('show');
    }
  
    onLeaveHandler() {
      this.cursor.classList.remove('show');
    }
  
    update() {
      super.update();
  
      if (this.currentPageElement && this.pageTotalElement) {
        const currentElement = this.sliderItemsToShow[this.currentPage - 1];
        if (currentElement) {
          this.slider.style.setProperty('--force-image-ratio-percent', currentElement.querySelector('.media').style.getPropertyValue('--image-ratio-percent'));
        }
      }
    }
  
    goToFirstSlide() {
      this.slider.scrollTo({
        left: 0
      });
    }
  }
    customElements.define('product-gallery', ProductGallery);
}

if (!customElements.get('variant-selects')) {
  class VariantSelects extends HTMLElement {
    constructor() {
      super();
  
      this.addEventListener('change', this.onVariantChange);
  
      this.updateOptions();
      this.updateMasterId();
      this.setAvailability();
    }
  
    onVariantChange(event) {
      this.updateOptions();
      this.updateMasterId();
      this.toggleAddButton(true, '', false);
      this.updatePickupAvailability();
      this.removeErrorMessage();
      this.validateGang();
  
      if (!this.currentVariant) {
        this.toggleAddButton(true, '', true);
        this.setUnavailable();
        this.setAvailabilityInUnavailable();
      } else {
        if(this.gangOption) {
          this.updateGangMedia();
        } else {
          this.updateMedia();
        }
        this.updateURL();
        this.updateVariantInput();
        this.renderProductInfo();
        this.setAvailability();
  
        document.dispatchEvent(new CustomEvent('variant:change', {
          detail: {
            variant: this.currentVariant
          }
        }));
      }
  
      this.handleStickyCart(event.target);
    }
  
    handleStickyCart(target) {
      const stickyCart = document.getElementById(`sticky-cart-${this.dataset.section}`);
      if (!stickyCart) return;
  
      const attribute = target.getAttribute('name');
  
      document.querySelectorAll(`variant-radios[data-section="${this.dataset.section}"] [name="${attribute}"], variant-selects[data-section="${this.dataset.section}"] [name="${attribute}"]`)
      .forEach((input) => {
        if (input.tagName === 'INPUT') {
          input.checked = input.value === target.value;
        }
        else {
          input.value = target.value;
        }
      });
  
      if (!this.currentVariant) return;
      if (!this.currentVariant.featured_media) return;
  
      const image = document.querySelector('.sticky-cart__content-image img');
      if (image) {
        image.srcset = `${this.currentVariant.featured_media.preview_image.src}&width=70 1x, ${this.currentVariant.featured_media.preview_image.src}&width=140 2x`;
        image.src = `${this.currentVariant.featured_media.preview_image.src}&width=70`;
        image.width = 70;
        image.height = Math.ceil(70 / this.currentVariant.featured_media.preview_image.aspect_ratio);
      }
    }
  
    updateOptions() {
      this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
    }
  
    updateMasterId() {
      this.currentVariant = this.getVariantData()?.find((variant) => {
        return !variant.options.map((option, index) => {
          return this.options[index] === option;
        }).includes(false);
      });
    }
    
    validateGang() {
      const mediaItemWithGang = document.querySelector(`#shopify-section-${this.dataset.section} [data-gang-option], quick-view-drawer details[open] [data-gang-option]`);
      if (mediaItemWithGang) {
        this.gangOption = mediaItemWithGang.dataset.gangOption;
      }
    }
    
    updateGangMedia() {
      if (!this.gangOption) return;
  
      const variantInputWrapper = this.querySelector('.variant-input-wrapper[data-option-slug="'+this.gangOption+'"]');
      if (variantInputWrapper) {
        this.gangIndex = variantInputWrapper.dataset.optionIndex;
      } else {
        this.gangOption = null;
      }
  
      if (!this.currentVariant) return;
      //if (!this.currentVariant.featured_media) return;
  
      const mediaGallery = document.getElementById(`MediaGallery-${this.dataset.section}`);
      const gangValue = this.getSlug(this.currentVariant[this.gangIndex]);
      if (this.currentGangValue !== gangValue) {
        document.querySelectorAll(
          `#shopify-section-${this.dataset.section} [data-gang-connect], quick-view-drawer details[open] [data-gang-connect]`
        ).forEach(function(media){
          media.classList.remove('gang__active');
        });
  
        this.currentGangValue = gangValue;
        var gangConnect = this.gangOption + '_' + gangValue;
        const newMedias = document.querySelectorAll(
          `#shopify-section-${this.dataset.section} [data-gang-connect="${gangConnect}"], quick-view-drawer details[open] [data-gang-connect="${gangConnect}"]`
        );
  
        if (!newMedias.length) return;
        Array.from(newMedias).reverse().forEach(function(newMedia) {
          newMedia.classList.add('gang__active');
          let parent = newMedia.parentElement;
          if (parent.firstChild != newMedia) {
            parent.prepend(newMedia);
            parent.classList.add('product__media-no-animate');
          }
        });
  
        const thumbnailSlider = document.getElementById(`GalleryThumbnails-${this.dataset.section}`);
        if (thumbnailSlider) {
          const inactiveItems = thumbnailSlider.querySelectorAll('.thumbnail-list__item:not(.gang__active)');
          thumbnailSlider.slider.dataset.mediaCount = thumbnailSlider.sliderItems.length - inactiveItems.length;
          if (thumbnailSlider.slider.dataset.mediaCount < 2) {
            thumbnailSlider.classList.add('hidden');
          } else {
            thumbnailSlider.classList.remove('hidden');
          }
          thumbnailSlider.resetPages();
        }
  
        if (!mediaGallery) {
          const productGallery = document.querySelector(`#shopify-section-${this.dataset.section} product-gallery, quick-view-drawer details[open] product-gallery`)
          if (productGallery) {
            productGallery.resetPages();
            productGallery.goToFirstSlide();
          }
        }
  
        const gallerySliderButtons = document.querySelector(`#shopify-section-${this.dataset.section} product-gallery .slider-buttons, quick-view-drawer details[open] product-gallery .slider-buttons`);
        if (gallerySliderButtons) {
          if (document.querySelectorAll(`#shopify-section-${this.dataset.section} product-gallery .product__media-item.gang__active, quick-view-drawer details[open] product-gallery .product__media-item.gang__active`).length < 2) {
            gallerySliderButtons.classList.add('hidden');
          } else {
            gallerySliderButtons.classList.remove('hidden');
          }
        }
      }
  
      if (!this.currentVariant.featured_media) {
        if(!document.querySelectorAll(`#shopify-section-${this.dataset.section} product-gallery .product__media-item.gang__active.is-active, quick-view-drawer details[open] product-gallery .product__media-item.gang__active.is-active`).length) {
          document.querySelector(`#shopify-section-${this.dataset.section} product-gallery .product__media-item.gang__active, quick-view-drawer details[open] product-gallery .product__media-item.gang__active`).classList.add('is-active');
        }
        return;
      }
      
      if (mediaGallery) {
        const scrollIntoView = typeof this.dataset.noScroll === 'undefined';
        mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true, scrollIntoView);
      }
      
      const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
      if (modalContent) {
        const newMediaModal = modalContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
        modalContent.prepend(newMediaModal);
      }
      
      const thumbnailContent = document.querySelector(`#ProductThumbnails-${this.dataset.section}`);
      if (thumbnailContent) {
        const newMediaThumbnail = thumbnailContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
        thumbnailContent.prepend(newMediaThumbnail);
      }
    }
  
    getSlug(someString) {
      return someString.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
    }
  
    updateMedia() {
      if (!this.currentVariant) return;
      if (!this.currentVariant.featured_media) return;
      const newMedia = document.querySelector(
        `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
      );
  
      if (!newMedia) return;
      
      const parent = newMedia.parentElement;
      if (parent.firstChild == newMedia) return;
      parent.prepend(newMedia);
      parent.classList.add('product__media-no-animate');
  
      const mediaGallery = document.getElementById(`MediaGallery-${this.dataset.section}`);
      if (mediaGallery) {
        const scrollIntoView = typeof this.dataset.noScroll === 'undefined';
        mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true, scrollIntoView);
      }
  
      const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
      if (modalContent) {
        const newMediaModal = modalContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
        modalContent.prepend(newMediaModal);
      }
      
      const thumbnailContent = document.querySelector(`#ProductThumbnails-${this.dataset.section}`);
      if (thumbnailContent) {
        const newMediaThumbnail = thumbnailContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
        thumbnailContent.prepend(newMediaThumbnail);
      }
    }
  
    updateURL() {
      if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
      window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
    }
  
    updateVariantInput() {
      const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment, #product-form-${this.dataset.section}--alt`);
      productForms.forEach((productForm) => {
        const input = productForm.querySelector('input[name="id"]');
        input.value = this.currentVariant.id;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }
  
    updatePickupAvailability() {
      const pickUpAvailability = document.querySelector('pickup-availability');
      if (!pickUpAvailability) return;
  
      if (this.currentVariant && this.currentVariant.available) {
        pickUpAvailability.fetchAvailability(this.currentVariant.id);
      } else {
        pickUpAvailability.removeAttribute('available');
        pickUpAvailability.innerHTML = '';
      }
    }
  
    removeErrorMessage() {
      const section = this.closest('section');
      if (!section) return;
  
      const productForm = section.querySelector('product-form');
      if (productForm) productForm.handleErrorMessage();
    }
  
    renderProductInfo() {
      fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
        .then((response) => response.text())
        .then((responseText) => {
          this.updateSKU(responseText);
          this.updatePrice(responseText);
          this.updatePriceAlt(responseText);
          this.updateColorName(responseText);
          this.updateInventoryStatus(responseText);
          if (this.currentVariant) this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
  
          document.dispatchEvent(new CustomEvent('productInfo:loaded'));
        })
        .catch((e) => {
          console.error(e);
        });
    }
  
    updateSKU(responseText) {
      const id = `sku-${this.dataset.section}`;
      const html = new DOMParser().parseFromString(responseText, 'text/html');
      const destination = document.getElementById(id);
      const source = html.getElementById(id);
  
      if (source && destination) destination.innerHTML = source.innerHTML;
      if (destination) destination.classList.remove('visibility-hidden');
    }
  
    updatePrice(responseText) {
      const id = `price-${this.dataset.section}`;
      const html = new DOMParser().parseFromString(responseText, 'text/html');
      const destination = document.getElementById(id);
      const source = html.getElementById(id);
  
      if (source && destination) destination.innerHTML = source.innerHTML;
      if (destination) destination.classList.remove('visibility-hidden');
  
      /* Additional code for price change of AB test element */
      const abId = `ab-price-${this.dataset.section}`;
      const abDestination = document.getElementById(abId);
      const abSource = html.getElementById(abId);
  
      if (abSource && abDestination) abDestination.innerHTML = abSource.innerHTML;
      if (abDestination) abDestination.classList.remove('visibility-hidden');
    }
  
    updatePriceAlt(responseText) {
      const id = `price-${this.dataset.section}--alt`;
      const html = new DOMParser().parseFromString(responseText, 'text/html');
      const destination = document.getElementById(id);
      const source = html.getElementById(id);
  
      if (source && destination) destination.innerHTML = source.innerHTML;
      if (destination) destination.classList.remove('visibility-hidden');
    }
  
    updateColorName(responseText) {
      const html = new DOMParser().parseFromString(responseText, 'text/html');
      
      for (let index = 1; index <= 3; index++) {
        const id = index > 1 ? `color-${this.dataset.section}-${index}` : `color-${this.dataset.section}`;
        const destination = document.getElementById(id);
        const source = html.getElementById(id);
  
        if (source && destination) destination.innerHTML = source.innerHTML;
        if (destination) destination.classList.remove('visibility-hidden');
      }
    }
  
    updateInventoryStatus(responseText) {
      const id = `inventory-${this.dataset.section}`;
      const html = new DOMParser().parseFromString(responseText, 'text/html');
      const destination = document.getElementById(id);
      const source = html.getElementById(id);
  
      if (source && destination) destination.innerHTML = source.innerHTML;
      if (destination) destination.classList.remove('visibility-hidden');
    }
  
    toggleAddButton(disable = true, text, modifyClass = true) {
      const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-${this.dataset.section}--alt`);
      productForms.forEach((productForm) => {
        const addButton = productForm.querySelector('[name="add"]');
        if (!addButton) return;
  
        if (disable) {
          addButton.setAttribute('disabled', true);
          if (text) addButton.textContent = text;
        }
        else {
          addButton.removeAttribute('disabled');
          addButton.textContent = addButton.dataset.preOrder === 'true' ? window.variantStrings.preOrder : window.variantStrings.addToCart;
        }
  
        if (!modifyClass) return;
      });
    }
  
    setUnavailable() {
      const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-${this.dataset.section}--alt`);
      productForms.forEach((productForm) => {
        const addButton = productForm.querySelector('[name="add"]');
        if (!addButton) return;
        addButton.textContent = window.variantStrings.unavailable;
  
        const price = document.getElementById(`price-${this.dataset.section}`);
        if (price) price.classList.add('visibility-hidden');
  
        /* Additional code for AB test element */
        const abPrice = document.getElementById(`ab-price-${this.dataset.section}`);
        if (abPrice) abPrice.classList.add('visibility-hidden');
  
        const priceAlt = document.getElementById(`price-${this.dataset.section}--alt`);
        if (priceAlt) priceAlt.classList.add('visibility-hidden');
  
        const inventory = document.getElementById(`inventory-${this.dataset.section}`);
        if (inventory) inventory.classList.add('visibility-hidden');
      });
    }
  
    getVariantData() {
      this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
      return this.variantData;
    }
  
    setAvailability() {
      if (!this.currentVariant) return;
  
      this.querySelectorAll('.variant-input-wrapper').forEach(group => {
        this.disableVariantGroup(group);
      });
  
      const currentlySelectedValues = this.currentVariant.options.map((value,index) => {return {value, index: `option${index+1}`}})
      const initialOptions = this.createAvailableOptionsTree(this.variantData, currentlySelectedValues, this.currentVariant);
  
      for (var [option, values] of Object.entries(initialOptions)) {
        this.manageOptionState(option, values);
      }
    }
  
    setAvailabilityInUnavailable() {
      this.querySelectorAll('.variant-input-wrapper').forEach(group => {
        this.disableVariantGroup(group);
      });
  
      const currentlySelectedValues = this.options.map((value,index) => {return {value, index: `option${index+1}`}})
      const initialOptions = this.createAvailableOptionsTree(this.variantData, currentlySelectedValues, this.currentVariant);
  
      for (var [option, values] of Object.entries(initialOptions)) {
        this.manageOptionState(option, values);
      }
    }
  
    enableVariantOption(group, obj) {
      const value = obj.value.replace(/([ #;&,.+*~\':"!^$[\]()=>|\/@])/g,'\\$1');
      group.querySelector('option[value="'+ value +'"]').disabled = false;
    }
  
    disableVariantGroup(group) {
      group.querySelectorAll('option').forEach((option) => {
        option.disabled = true;
      });
    }
  
    manageOptionState(option, values) {
      const group = this.querySelector('.variant-input-wrapper[data-option-index="'+ option +'"]');
  
      // Loop through each option value
      values.forEach(obj => {
        this.enableVariantOption(group, obj);
      });
    }
  
    createAvailableOptionsTree(variants, currentlySelectedValues) {
      // Reduce variant array into option availability tree
      return variants.reduce((options, variant) => {
  
        // Check each option group (e.g. option1, option2, option3) of the variant
        Object.keys(options).forEach(index => {
  
          if (variant[index] === null) return;
  
          let entry = options[index].find(option => option.value === variant[index]);
  
          if (typeof entry === 'undefined') {
            // If option has yet to be added to the options tree, add it
            entry = {value: variant[index], soldOut: true}
            options[index].push(entry);
          }
  
          const currentOption1 = currentlySelectedValues.find(({value, index}) => index === 'option1')
          const currentOption2 = currentlySelectedValues.find(({value, index}) => index === 'option2')
  
          switch (index) {
            case 'option1':
              // Option1 inputs should always remain enabled based on all available variants
              entry.soldOut = entry.soldOut && variant.available ? false : entry.soldOut;
              break;
            case 'option2':
              // Option2 inputs should remain enabled based on available variants that match first option group
              if (currentOption1 && variant['option1'] === currentOption1.value) {
                entry.soldOut = entry.soldOut && variant.available ? false : entry.soldOut;
              }
            case 'option3':
              // Option 3 inputs should remain enabled based on available variants that match first and second option group
              if (
                currentOption1 && variant['option1'] === currentOption1.value
                && currentOption2 && variant['option2'] === currentOption2.value
              ) {
                entry.soldOut = entry.soldOut && variant.available ? false : entry.soldOut;
              }
          }
        })
  
        return options;
      }, { option1: [], option2: [], option3: []})
    }
  }
    customElements.define('variant-selects', VariantSelects);
  
  class VariantRadios extends VariantSelects {
    constructor() {
      super();
    }
  
    updateOptions() {
      const fieldsets = Array.from(this.querySelectorAll('fieldset'));
      this.options = fieldsets.map((fieldset) => {
        return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
      });
    }
  
    enableVariantOption(group, obj) {
      const value = obj.value.replace(/([ #;&,.+*~\':"!^$[\]()=>|\/@])/g,'\\$1');
      const input = group.querySelector('input[data-option-value="'+ value +'"]');
  
      // Variant exists - enable & show variant
      input.removeAttribute('disabled');
  
      // Variant sold out - cross out option (remains selectable)
      if (obj.soldOut) {
        input.setAttribute('disabled', '');
      }
    }
  
    disableVariantGroup(group) {
      group.querySelectorAll('input').forEach((input) => {
        input.setAttribute('disabled', '');
      });
    }
  }
    if (!customElements.get('variant-radios')) {
    customElements.define('variant-radios', VariantRadios);
  }
}

if (!customElements.get('progress-bar')) {
  class ProgressBar extends HTMLElement {
    constructor() {
      super();

      theme.initWhenVisible({
        element: this,
        callback: this.init.bind(this),
        threshold: 0
      });
    }

    init() {
      setTimeout(() => {
        const quantity = parseInt(this.dataset.quantity);
        this.style.setProperty('--progress-bar-width', `${quantity * 100 / 30}%`);
      }, 1e3);
    }
  }

  customElements.define('progress-bar', ProgressBar);
}
